import React from "react";
import { Row, Col } from "react-bootstrap";
import FormattedMessage from "@irati/utils/lang";
import { H6 } from "@irati/ui/src/Typography";
var UnavailableDeal = function () {
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 8, sm: 12 },
            React.createElement(H6, null,
                React.createElement(FormattedMessage, { id: "perks.components.dealBody.unavailableDeal.header" })))));
};
export default UnavailableDeal;
